var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.items,"filter":_vm.customFilter,"item-text":"name","label":_vm.label,"placeholder":"ポケモン名を入力","no-data-text":"見つかりません","auto-select-first":"","menu-props":"auto","clearable":"","hide-details":""},model:{value:(_vm._pokemon),callback:function ($$v) {_vm._pokemon=$$v},expression:"_pokemon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }